import React, { useContext, useState } from 'react'
import { ApiLinkContext } from '../context/ApiLinkContext';
import { LanguageContext } from '../context/LanguageContext';
import translations from '../data/langData';
import { NavLink } from 'react-router-dom';
import slugify from 'react-slugify';

const AllDate = () => {
    const { language } = useContext(LanguageContext);
    const t = translations[language];
    const { blogCat, blog } = useContext(ApiLinkContext);
    const [visible, setVisible] = useState(20);
  return (
    <>
       <h1 className="text-center my-5 text-uppercase">Xəbər Arxİvİ</h1>

       <div className="container">
           
            <div className="row">
                <div className="d-flex justify-content-end">
                    <select name="" id="" 
                    className='mb-5'
                     style={{
                        padding:"10px",
                        borderRadius:"20px",
                        border:"1px solid #20AD96"
                     }}
                    >
                        <option value="" disabled>Xəbər seç</option>
                        <option value="">Xəbərlər</option>
                        <option value="">Tədbir və təlimlər</option>
                    </select>
                </div>
              {blog.length > 0 &&
                blog.slice(0, visible).map((item) => {
                  return (
                    <div className="col-lg-4 col-sm-6 col-12">
                      <NavLink
                        to={`/${slugify(
                          `${item.id}-${item.name}`
                        ).toLowerCase()}`}
                      >
                        <div className="swiper-s mb-30 mx-2 pb-5">
                          <div className="course box-shadow">
                            <div className="thumbnail">
                              <a
                                href="#"
                                className="image"
                              >
                                <img src={item.img} alt="Course Image" id="newsImg" />
                              </a>
                            </div>
                            <div className="info">
                              <h3 className="title">
                                <a href="#">
                                {language == "az"
                                  ? item.name
                                  : language == "en"
                                  ? item.nameEn
                                  : language == "ru"
                                  ? item.nameRu
                                  : language == "tr"
                                  ? item.nameTr
                                  : language == "de"
                                  ? item.nameDe
                                  : language == "pl"
                                  ? item.namePl
                                  : ""}
                                </a>
                              </h3>
                              <p>
                                {item.descrip && item.descrip.slice(0, 81)}...
                              </p>
                              <ul className="meta">
                                <li>
                                  <i className="fas fa-file-alt" />
                                  {item.date}
                                </li>
                                <li>
                                  <i className="fas fa-user-alt" />
                                  {item.view} view
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </NavLink>
                    </div>
                  );
                })}
            </div>
            {visible < blog.length && (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  className="btn btn-success my-5"
                  onClick={() => setVisible((prevState) => prevState + 10)}
                >
                  DAHA ÇOX
                </button>
              </div>
            )}
          </div>
    </>
  )
}

export default AllDate
